import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Checkbox, message } from 'antd';
import { FileAddOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { find } from 'lodash';
import dayjs from 'dayjs';

import {
    loadComplianceActivities,
    setShowall,
    createNewActivityItem,
    submitSelectedActivitiesForProcessing
} from '../actions';
import * as constants from '../constants';
import NewActivityForm from './NewActivityForm';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';
import { SelectableService } from 'ag-grid-community';

const { AgGridWithState } = core;
const { currentUserHasRights, RendererBoolean, RendererStatus } = common;

const dateFormatter = (params) => {
    if (params.value) {
        return dayjs(params.value).format('DD-MM-YYYY');
    } else {
        return '';
    }
}
class ComplianceActivitiesGrid extends Component {

    state = {
        selectedIdProcessingActivity: 0,
        currentEditEntity: {},
        editFormVisible: false,
        addFormVisible: false,
        startingWfs: false,
    }

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.loadComplianceActivities(this.props.showall);
    }
    componentWillUnmount() {
        if (this.gridApi) {
            var columnState = this.gridApi.getColumnState()
            var filterModel = this.gridApi.getFilterModel()
            this.props.saveGridFilters('ComplianceActivitiesGrid', { columnState, filterModel })
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ComplianceActivitiesGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            return ''
        }
    }
    refreshClicked = () => {
        this.props.loadComplianceActivities(this.props.showall);
    }

    getGridCols = () => {
        let cols = [
            { key: "statusText", headerName: this.label("Status"), field: "statusText", checkboxSelection: (params) => params.data ? params.data.status !== 10 && params.data.status > 1 : false,
                 sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 120, minWidth: 120, maxWidth: 120 },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },

            { key: "name", headerName: this.label("Name"), field: "name", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "responsiblePersonDep", headerName: this.label("ResponsiblePersonDep"), field: "responsiblePersonDep", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "company", width: 70, headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "reviewDate", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("ReviewDate"), field: "reviewDate", sortable: true, filter: true, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", valueFormatter: dateFormatter },
            { key: "businessProcess", headerName: this.label("BusinessProcess"), field: "businessProcess", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;


        if (this.props.gridfilterstate) {
            this.gridApi.applyColumnState({ state: this.props.gridfilterstate.columnState, applyOrder: true });
            this.gridApi.setFilterModel(this.props.gridfilterstate.filterModel);
        }
    };
    deselectAll = () => {
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }

    //#region Grid/Button handlers

    onStartWorkflowOnSelectionClicked = async () => {
        if (this.gridApi) {
            let selection = this.gridApi.getSelectedRows();
            if(selection.length > 0){
                this.setState({startingWfs : true});
                
                let ids = selection.map(item => {return item.idProcessingActivity});
                let res = await this.props.submitSelectedActivitiesForProcessing(ids);
                
                this.setState({startingWfs : false});
                if(res.length > 0){
                    res.forEach(item =>  message.error(item, 15));
                } else {
                    message.success('Workflow(s) started', 5);
                }
                this.refreshClicked();
            }
        }
    }

    handleCheckShowAll = async (e) => {
        await this.props.setShowall(e.target.checked);
        this.refreshClicked();
    }

    onDoubleClick = async (dataitem) => {
        this.props.history.push(`/app/processingactivities/${dataitem.idProcessingActivity}`)
    }

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: {
                processingActivity: {

                    hasDataProcessor: false,
                    processingAgreement: false,
                    dpiaRequired: false
                },
                legalGrounds: [],
                informationCarriers: [],
                processedData: [],
                recipients: [],
            },
            addFormVisible: true,
        });
    }

    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = async (values) => {
        console.log(values);
        await this.props.createNewActivityItem(values);

        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
        this.refreshClicked();
    }


    //#endregion

    render() {
        const loading = this.props.loadingActivities || this.state.startingWfs;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='activities'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("Activities")}</span>
                        <Checkbox style={{ margin: 5, marginLeft: 15 }} checked={this.props.showall} onChange={this.handleCheckShowAll}>{this.label("ShowAllActivities")}</Checkbox>
                        <Button type="primary" icon={<FileAddOutlined />} onClick={this.onAddClicked} style={{ margin: 5, marginLeft: 15 }} >{this.label("NewItem")}</Button>
                        <Button icon={<ThunderboltOutlined />} onClick={this.onStartWorkflowOnSelectionClicked} style={{ margin: 5, marginLeft: 35 }} >{this.label("StartWorkflows")}</Button>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                            rowSelection='multiple'
                            lang={this.props.curLanguage}
                            onReady={this.onGridReady}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.activities}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            isRowSelectable={(rowNode => rowNode.data ? rowNode.data.status != 10 && rowNode.data.status>1: false)}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                    </>
                )}

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <NewActivityForm contentheight={gridHeight - 20}
                        datacontext={this.state.currentEditEntity}
                        onSave={this.handleEntityAdd}
                        onCancel={this.handleCancelForm} />
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingActivities: state[constants.NAME].loadingActivities,
        activities: state[constants.NAME].activities,
        showall: state[constants.NAME].showall,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
        gridfilterstate: state[uistate.constants.NAME].gridfilterstate['ComplianceActivitiesGrid'],
    };
}

export default connect(mapStateToProps,
    {
        loadComplianceActivities,
        setShowall,
        createNewActivityItem,
        submitSelectedActivitiesForProcessing,
        saveGridFilters: uistate.actions.saveGridFilters
    })(ComplianceActivitiesGrid);